export default {
  title: 'Personeelsgegevens',
  form: {
    username: {
      label: 'Gebruikersnaam',
      placeholder: 'Gebruikersnaam',
    },
    password: {
      label: 'Wachtwoord',
      placeholder: 'Wachtwoord',
    },
    button: {
      title: 'Opslaan',
    },
    success: 'Uw gegevens zijn succesvol opgeslagen.',
  },
};
